import { Stack, Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

type Props = {
	sentAt: Date;
};

export const BalanceLeadSentNote: FC<Props> = ({ sentAt }) => {
	const theme = useTheme();
	const { t } = useResource();
	const color = theme.palette.grey[500];

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.xs}
			mt={theme.spacingTokens.xs}
		>
			<Check size={theme.iconSize.xs} color={color} aria-hidden />
			<Typography variant="caption" color={color}>
				{t(Resources.Finances.Recommendation.sent, {
					date: dateFormatter(sentAt),
				})}
			</Typography>
		</Stack>
	);
};
